import clsx from 'clsx'

import { Paper } from 'shared/ui/paper'

import { Switch } from '../switch'

import s from './styles.module.scss'

interface FlexibleDepartureCellProps {
  title: string
  description?: string
  className?: string
  isCard?: boolean
  isEnabled: boolean
  onToggle?: (enabled: boolean) => void
}

export const FlexibleDepartureCell = ({
  title,
  description,
  className,
  isCard = true,
  isEnabled,
  onToggle,
}: FlexibleDepartureCellProps) => {
  const handleToggle = (checked: boolean) => {
    onToggle?.(checked)
  }

  return (
    <Paper
      padding={[14, 16]}
      className={clsx(s.container, className, isCard && s.card)}
    >
      <div className={s.stateLayer}>
        <div className={s.content}>
          <p className={clsx('bold-16', s.title)}>{title}</p>
          {description && (
            <p className={clsx('semi-bold-14', s.description)}>{description}</p>
          )}
        </div>
        <Switch
          isChecked={isEnabled}
          onChange={handleToggle}
        />
      </div>
    </Paper>
  )
}
